import { AdmDataGrid } from "@components/common/data-grid/adm-data-grid";
import { AdmMember } from "@custom-types/base-types";
import { useSearchMembersTableColumns } from "@pages/home/search/search-tables/search-members-tables/use-search-members-table-columns";
import { useGenerateRoutes } from "@router/router-helper";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { MainPageEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";

interface Props {
  /** List of members that match the search text */
  members: AdmMember[];
}

/** Shows a list of members that match the search text */
export function SearchMembersTable({ members }: Props): React.JSX.Element {
  const columns = useSearchMembersTableColumns();
  const { generateMemberRoute } = useGenerateRoutes();
  const { trackEvent } = useTrackEvent();

  return (
    <AdmDataGrid
      entities={members}
      uniqueIdKey="identity"
      tableType="search-members-table"
      columns={columns}
      // Data is coming from somewhere else with error handling. So no need to show error in here.
      errorMessage=""
      shouldShowErrorMessage={false}
      // Only active members have a profile to open
      isRowClickable={FaroCoreApiUtils.Member.isMemberActive}
      onRowClick={() => {
        trackEvent({
          name: MainPageEvents.openItem,
          props: {
            target: "USER",
            location: "search result",
          },
        });
      }}
      getRowLink={(member) =>
        generateMemberRoute({ memberId: member.identity })
      }
      defaultSortModel={[{ field: "name", sort: "asc" }]}
    />
  );
}
